import React from 'react'
import { Form, reduxForm, } from 'redux-form'
import {
  compose, nest, withProps, withPropsOnChange,
} from 'recompose'
import { Combobox } from 'react-widgets'
import { connect } from 'react-redux'
import values from 'lodash/values'
import get from 'lodash/get'
import { addNotification as notify } from 'reapop'

import {
  Collapse,
  FieldWithTitle,
  InputHelper,
  Input,
  DateTimePickerField,
  FileUploadTransport,
  Multiselect,
} from '@infotech/base-components'
import { getEntities, CALL_API } from '@infotech/lib-api-middleware'
import { UserSelect } from '@infotech/4sides-components'
import { PrimaryButton, } from '@infotech/uikit-button'
import { withToken } from '@infotech/auth'
import { createNotifyConf } from '@infotech/notify'

const WORKLOG_FORM = `WORKLOG_FORM`

const TextArea = withProps(() => ({ type:`textarea` }))(Input)
const InputComponent = nest(InputHelper, TextArea)
const InputSimpleComponent = nest(InputHelper, Input)


const Users = withProps(() => ({ currentUserIsDefault: false }))(UserSelect)
const UsersComponent = nest(InputHelper, Users)

const DateTimeComponent = nest(InputHelper, DateTimePickerField)

const FileUploadTransportEnhance = withToken(FileUploadTransport)

const ReasonsField = compose(
  connect((state) => ({
    reasons: getEntities(state, `violation_reason`),
  })),
  withPropsOnChange([`reasons`], ({ reasons }) => ({
    data: values(reasons),
    textField: `name`,
    valueField: `code`,
    filter: `contains`,
  })),
  withProps(({ input: { onChange, value } }) => ({
    onSelect: val => onChange(val.code),
    value,
  })),
)(Combobox)
const ReasonsComponent = nest(InputHelper, ReasonsField)

const TypesField = compose(
  connect((state) => ({
    types: getEntities(state, `work_kind`),
  })),
  withPropsOnChange([`types`], ({ types }) => ({
    data: values(types),
    textField: `name`,
    valueField: `code`,
    filter: `contains`,
  })),
)(Multiselect)
const TypesComponent = nest(InputHelper, TypesField)

const onSubmit = (
  values,
  dispatch,
  { data: { id }, initialize },
) => {
  const violationReason = get(values, `violationReason`, [])
  const workTypeCodeList = get(values, `workTypeCodeList`, [])
  const description = get(values, `description`)
  const usedMaterials = get(values, `usedMaterials`)
  const documentNumber = get(values, `documentNumber`)

  if (!violationReason.length || !workTypeCodeList.length || !description || !usedMaterials || !documentNumber) {
    dispatch(notify(createNotifyConf(`Ошибка: обязательные поля должны быть заполнены`, `error`)))
    return
  }

  const request = {
    type: `WORKLOG_PUT`,
    [CALL_API]: {
      url: `/core/modules/ahp/techviolation/issues/worklogs/${id}`,
      options: {
        method: `PUT`,
        body: {
          "documentType": "1",
          "documentIssueDate": 1519129853500,
          ...values
        },
      },
    },
  }

  dispatch(request).then((response) => {
    if (response.error) {
      dispatch(notify(createNotifyConf(response.error.exception || `Ошибка`, `error`)))
      return
    }
    dispatch(notify(createNotifyConf(`Отчет сохранен`, `success`)))
    const worklog = get(response, `response.json`)
    initialize({ ...worklog }) // reset form to values from backend
  })

}

const enhancer = compose(
  reduxForm({
    form: WORKLOG_FORM,
    onSubmit,
  }),
  connect(null, (dispatch, { data: { id }, initialize }) => ({
    fetchWorklog: () => {
      const request = {
        type    : `WORKLOG_GET`,
        [CALL_API]: {
          url: `/core/modules/ahp/techviolation/issues/worklogs/${id}`,
          query: { },
        },
      }

      dispatch(request).then((response) => {
        if (response.error) {
          // журнал отсутствует
          return
        }
        const worklog = get(response, `response.json`)
        initialize({ ...worklog })
      })
    },
  })),
  withPropsOnChange([], ({ fetchWorklog }) => {
    fetchWorklog()
  }),
)

const WorklogWidget = ({ handleSubmit }) => {
  return <Collapse
      title="Отчет о проделанной работе"
      isOpen={false}
    >
    <div className="mt-3 mb-3 ml-3 mr-3 worklog-form">
      <Form onSubmit={handleSubmit}>
        <FieldWithTitle
          component={ReasonsComponent}
          title="Причины ТН"
          formName={WORKLOG_FORM}
          name="violationReason"
          required={true}
        />
        <FieldWithTitle
          component={TypesComponent}
          title="Тип работ"
          formName={WORKLOG_FORM}
          name="workTypeCodeList"
          required={true}
        />
        <FieldWithTitle
          component={InputComponent}
          title="Выполненные работы"
          formName={WORKLOG_FORM}
          name="description"
          required={true}
        />
        <FieldWithTitle
          component={InputComponent}
          title="Использованные материалы"
          formName={WORKLOG_FORM}
          name="usedMaterials"
          required={true}
        />
        <FieldWithTitle
          component={InputSimpleComponent}
          title="Номер документа"
          formName={WORKLOG_FORM}
          name="documentNumber"
          required={true}
        />
        <FieldWithTitle
          component={FileUploadTransportEnhance}
          title="Файлы"
          formName={WORKLOG_FORM}
          name="files"
          required={false}
        />
        <FieldWithTitle
          component={UsersComponent}
          title="Создатель"
          formName={WORKLOG_FORM}
          name="createdBy"
          required={false}
          disabled={true}
        />
        <FieldWithTitle
          component={DateTimeComponent}
          title="Дата создания"
          formName={WORKLOG_FORM}
          name="createDate"
          required={false}
          disabled={true}
        />
        <PrimaryButton>
          Сохранить отчет
        </PrimaryButton>
      </Form>
    </div>
  </Collapse>
}

export default enhancer(WorklogWidget)